<div class="hubspot-form">
    @if (state === 'loading') {
        <div class="status status-loading">
            Loading form…
        </div>
    }

    @if (state === 'error') {
        <div class="status status-error">
            Form failed to load. Please refresh and try again.
        </div>
    }

    @if (state === 'disabled') {
        <div class="status status-disabled">
            HubSpot form is disabled in this environment.
        </div>
    }

    <div [id]="targetId" class="embed-target"></div>
</div>

